import { motion } from "framer-motion";

interface StreakCounterProps {
  streak: number;
  size?: "sm" | "md" | "lg";
}

export const StreakCounter = ({ streak, size = "md" }: StreakCounterProps) => {
  const sizeClasses = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg"
  };

  if (streak === 0) return null;

  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-gradient-to-r from-warning/20 to-warning/10 border border-warning/30 ${sizeClasses[size]}`}
    >
      <motion.span
        animate={{ 
          scale: [1, 1.2, 1],
          rotate: [0, 10, -10, 0]
        }}
        transition={{ 
          repeat: Infinity,
          duration: 2,
          ease: "easeInOut"
        }}
        className="text-warning"
      >
        🔥
      </motion.span>
      <span className="font-bold text-foreground">{streak}</span>
      <span className="text-sm text-muted-foreground">day streak</span>
    </motion.div>
  );
};